import { render, staticRenderFns } from "./DoctorSpecializationSearchableSelect.vue?vue&type=template&id=1522239e"
import script from "./DoctorSpecializationSearchableSelect.vue?vue&type=script&lang=js"
export * from "./DoctorSpecializationSearchableSelect.vue?vue&type=script&lang=js"
import style0 from "./DoctorSpecializationSearchableSelect.vue?vue&type=style&index=0&id=1522239e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports